import store from "@/store";
const ability = store.getters.ability;

export const checkPermission = (permission) => {
  const [subject, action] = permission.split(":");
  return ability.can(action, subject);
};
